import type { MarketStackParamList } from '../Navigator';
import { useNavigation } from '@react-navigation/native';
import type { NativeStackNavigationProp } from '@react-navigation/native-stack';

export const useMarketNavigation = <Key extends keyof MarketStackParamList>() =>
  useNavigation<NativeStackNavigationProp<MarketStackParamList, Key>>();
